"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThcFilterOption = void 0;
const products_1 = require("@getgreenline/products");
const RangeFilterOption_1 = require("./RangeFilterOption");
class ThcFilterOption extends RangeFilterOption_1.RangeFilterOption {
    constructor() {
        super(...arguments);
        this.singleValueKey = products_1.MetaDataModels.MetaDataReservedKeys.THC;
        this.minValueKey = products_1.MetaDataModels.MetaDataReservedKeys.MIN_THC;
        this.maxValueKey = products_1.MetaDataModels.MetaDataReservedKeys.MAX_THC;
    }
}
exports.ThcFilterOption = ThcFilterOption;
//# sourceMappingURL=ThcFilterOption.js.map